// import axios from "axios";
import groupActionTypes from "../types/groupActionTypes";
import groupService from "./../../services/groups.service";
import actionType from '../../enums/actionEnum'

export const getGroups = () => async (dispatch) => {
    try {
        var response = await groupService.getGroups();
        dispatch({
            type: groupActionTypes.GET_GROUPS_SUCCESS,
            payload: response.data,

        });
    } catch (error) {
        dispatch({
            type: groupActionTypes.GET_GROUPS_FAILURE,
            payload: error,
        });
    }

};

export const updateGroup = (group) => async (dispatch) => {

    try {
        dispatch({
            type: groupActionTypes.START_UPDATE_GROUP,
        });
        var response = await groupService.updateGroup(group);
        dispatch({
            type: groupActionTypes.UPDATE_GROUP_SUCCESS,
            payload: response.data,
            action: actionType.update
        });
    } catch (error) {
        dispatch({
            type: groupActionTypes.UPDATE_GROUP_FAILURE,
            payload: error.response,
            action: actionType.update
        });

    }
};

export const AttachChargerToGroup = (chargerId,groupId,attach) => async (dispatch) => {

    try {
        dispatch({
            type: groupActionTypes.START_ATTACH_CHARGER_GROUP,
        });
        var response = await groupService.attachChargerToGroup(chargerId, groupId, attach);
        dispatch({
            type: groupActionTypes.ATTACH_CHARGER_GROUP_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: groupActionTypes.ATTACH_CHARGER_GROUP_FAILURE,
            payload: error.response,
        });

    }
};

export const addGroup = (group) => async (dispatch) => {

    try {
        dispatch({
            type: groupActionTypes.START_ADD_GROUP,
        });
        var response = await groupService.addGroup(group);
        dispatch({
            type: groupActionTypes.ADD_GROUP_SUCCESS,
            payload: response.data,
            action: actionType.add
        });
    } catch (error) {
        dispatch({
            type: groupActionTypes.ADD_GROUP_FAILURE,
            payload: error.response,
            action: actionType.add
        });

    }
};

export const deleteGroup = (id) => async (dispatch) => {
    try {
        dispatch({
            type: groupActionTypes.START_DELETE_GROUP,
        });
        var response = await groupService.deleteGroup(id);
        dispatch({
            type: groupActionTypes.DELETE_GROUP_SUCCESS,
            payload: response.data,
            action: actionType.delete
        });
    } catch (error) {
        dispatch({
            type: groupActionTypes.DELETE_GROUP_FAILURE,
            payload: error.response,
            action: actionType.delete

        });

    }
};


export const setSelectedGroup = selectedGroup => (dispatch) => {
    dispatch({ type: groupActionTypes.SELECT_GROUP, payload: selectedGroup });
};

export const UnSelecteGroup =()=> (dispatch) => {
    localStorage.removeItem('selectedGroup');
    dispatch({ type: groupActionTypes.UNSELECT_GROUP });
};

export const resetStateInfo = () => (dispatch) => {
    dispatch({ type: groupActionTypes.RESET_STATE_INFO })
};



const groupActions = {
    getGroups,
    addGroup,
    updateGroup,
    deleteGroup,
    setSelectedGroup,
    UnSelecteGroup,
    resetStateInfo,
    AttachChargerToGroup
};
export default groupActions;







